"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableResponseErrorFeature = exports.enableResponseErrorFeature = exports.disableResponseFeature = exports.enableResponseFeature = exports.disableRequestFeature = exports.enableRequestFeature = exports.setLoggerInjector = void 0;
const index_1 = require("./index");
var index_2 = require("./index");
Object.defineProperty(exports, "setLoggerInjector", { enumerable: true, get: function () { return index_2.setLoggerInjector; } });
/**
 * 开启每个 Request 的 Debug
 *
 * *每次请求的 Request 都将打印*
 */
const enableRequestFeature = () => { index_1.RequestFeature.setContext(); };
exports.enableRequestFeature = enableRequestFeature;
/**
 * 关闭每个 Request 的 Debug
 */
const disableRequestFeature = () => { index_1.RequestFeature.removeContext(); };
exports.disableRequestFeature = disableRequestFeature;
/**
 * 开启每个 Response 的 Debug
 *
 * *每次请求后的 Response 都将打印*
 */
const enableResponseFeature = () => { index_1.ResponseFeature.setContext(); };
exports.enableResponseFeature = enableResponseFeature;
/**
 * 关闭每个 Response 的 Debug
 */
const disableResponseFeature = () => { index_1.ResponseFeature.removeContext(); };
exports.disableResponseFeature = disableResponseFeature;
/**
 * 开启每个 Response Error 的 Debug
 *
 * *每次请求后的 Response 如果发生错误都将打印出来*
 */
const enableResponseErrorFeature = () => { index_1.ResponseErrorFeature.setContext(); };
exports.enableResponseErrorFeature = enableResponseErrorFeature;
/**
 * 关闭每个 Response Error 的 Debug
 */
const disableResponseErrorFeature = () => { index_1.ResponseErrorFeature.removeContext(); };
exports.disableResponseErrorFeature = disableResponseErrorFeature;
//# sourceMappingURL=external.js.map